export interface BoxValues {
	top?: string;
	right?: string;
	bottom?: string;
	left?: string;
}

export interface BoxControlProps {
	/** Current box values */
	value?: BoxValues;
	/** Callback function when values change */
	onChange: ( value: BoxValues ) => void;
	/** Whether all sides should be linked (same value) */
	splitOnAxis?: boolean;
	/** Default unit for all sides */
	units?: Array< {
		value: string;
		label: string;
		default?: number;
	} >;
	/** Placeholder text for inputs */
	placeholder?: string;
	/** Whether to show all sides individually or grouped */
	showAllSides?: boolean;
	/** Minimum value allowed */
	min?: number;
	/** Maximum value allowed */
	max?: number;
	/** Step value for increment/decrement */
	step?: number;
	/** Whether the control is disabled */
	disabled?: boolean;
	/** Additional CSS class names */
	className?: string;
	/** Whether to reset on first render if empty */
	resetFallbackValue?: string;
	/** Side labels */
	sides?: {
		top?: string;
		right?: string;
		bottom?: string;
		left?: string;
	};
	/** Whether the control is a radius control */
	isRadius?: boolean;
}

export enum BoxSide {
	TOP = 'top',
	RIGHT = 'right',
	BOTTOM = 'bottom',
	LEFT = 'left',
}
